import translations from '../translations';

export const getErrorMessageFrom = (error, defaultErrorMessage = "") => {
  return (error.response && error.response.data && error.response.data.errorDescription) ||
    error.message ||
    defaultErrorMessage;
};

export const getFramingErrorMessageFrom = (error, defaultErrorMessage = "") => {
  return (error.response && error.response.data && error.response.data.detail) ||
      error.message ||
      defaultErrorMessage;
};

export const getDownloadErrorMessageBy = (error, language) => {
  let errorMessage = getErrorMessageFrom(error, translations('unableDownloadProducts', language));
  if (error.code === "ECONNABORTED" || errorMessage === "Read timed out") {
    errorMessage = translations('errorBeforeProceedingDownload', language);
  }
  return errorMessage;
};

export const getSubmitErrorMessageBy = (error, language) => {
  let errorMessage = getErrorMessageFrom(error, translations('unableSubmitJobs', language));
  if (error.code === "ECONNABORTED" || errorMessage === "Read timed out") {
    errorMessage = translations('errorBeforeProceedingJobs', language);
  }
  return errorMessage;
};
